import { render } from "./CaseVideos.vue?vue&type=template&id=e2167b4c&ts=true"
import script from "./CaseVideos.vue?vue&type=script&lang=ts"
export * from "./CaseVideos.vue?vue&type=script&lang=ts"

import "./CaseVideos.vue?vue&type=style&index=0&id=e2167b4c&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__